import { TinyEmitter } from "@expert/event-bus";

import type { ExpertWorkspaceWebSocketMessageType } from "./types";

export const WS_EMITTER_NAME = "ws";
export type ExpertWorkspaceWebSocketEvents = Record<
    `${typeof WS_EMITTER_NAME}_${ExpertWorkspaceWebSocketMessageType}`,
    // fixme: move conference event types somewhere where they can be imported without causing cyclical dependencies
    any
>;
export type ExpertWorkspaceWebSocketEventType = keyof ExpertWorkspaceWebSocketEvents;

// WS payloads are raw, `any`-typed backend messages. Nest them under `payload` in emit logs
// (rather than spreading to top-level fields) so their arbitrary field names (e.g. startTime /
// endTime / ts) don't leak into the shared account-level `remote-expert` log index, whose
// per-rollover dynamic mapping otherwise hits date-vs-text type conflicts and fails dashboards.
export const expertWorkspaceWebSocketEventBus = new TinyEmitter<ExpertWorkspaceWebSocketEvents>(WS_EMITTER_NAME, {
    loggingEnabled: true,
    nestPayloadInLogs: true,
});
